<app-period-tab-list
    [periods]="periods"
    [measurementCycle]="measurementCycle"
    [contentTemplate]="periodTemplate"
></app-period-tab-list>

<ng-template #periodTemplate let-period="period">
    <app-period-breakdown [period]="period"></app-period-breakdown>
</ng-template>
